import {getCachedTableStateSlice} from 'src/hooks/common-data-service/cached-table';

import type {AccountAuditLogCriteria} from '../typedef';
import type {CachedTableStateSelector} from 'src/hooks/common-data-service/cached-table/typedef';


export const accountAuditLogStateSlice = getCachedTableStateSlice<
    undefined,
    undefined,
    AccountAuditLogCriteria
>('accountAuditLogState', undefined);

export const accountAuditLogStateActions = accountAuditLogStateSlice.actions;
export const accountAuditLogStateSelector: CachedTableStateSelector<
    undefined,
    undefined,
    AccountAuditLogCriteria
> = state => state.accountPage.tabs.accountAuditLog.state;
